module.exports = __webpack_public_path__ + "static/media/icn_events_60x60.1a562968.svg";